var exports = {
  "gx": "NameStyleText.module__font___ZWZRM3",
  "QJ": "NameStyleText.module__solid___ZWZRM3",
  "f1": "NameStyleText.module__defaultOnLight___ZWZRM3",
  "D7": "NameStyleText.module__gradient___ZWZRM3",
};

module.exports = exports;
